import React, { useState, useEffect } from "react";
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import LeftSection from './LeftSection';
import SearchbarSection from './SearchbarSection';
import RightSection from './RightSection';

const SearchVehicle = () => {
    const [vehicles, setVehicles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const location = useLocation();

    const getQueryParam = (param) => {
        const params = new URLSearchParams(location.search);
        return params.get(param) || '';
    };

    useEffect(() => {
        const keyword = getQueryParam('keyword');
        if (keyword) {
            fetchVehicles(keyword);
        }
    }, [location]);

    const fetchVehicles = async (keyword) => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await axios.get('https://skcapi.btcjapan.co/search_vehicles.php', {
                params: { keyword }
            });
            if (response.data.success) {
                setVehicles(response.data.results || []);
            } else {
                setError(response.data.message || 'No vehicles found.');
                setVehicles([]);
            }
        } catch (err) {
            setError('Failed to fetch vehicles. Please try again.');
            setVehicles([]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-2 leftcol">
                    <LeftSection />
                </div>
                <div className="col-8 middlecol">
                    <SearchbarSection />
                    <div className="container mt-5">
                        <h2>Search Results</h2>
                        {isLoading && <div className="alert alert-info">Loading...</div>}
                        {error && <div className="alert alert-danger">{error}</div>}
                        {vehicles.length === 0 && !isLoading && !error && (
                            <div className="alert alert-warning">No vehicles found matching your search.</div>
                        )}
                        <div className="row">
                            {vehicles.map((vehicle) => (
                                <div key={vehicle.id} className="col-md-4 mb-4">
                                    <div className="card h-100">
                                        {vehicle.images && (
                                            <img
                                                src={`https://skcapi.btcjapan.co/${vehicle.images}`}
                                                className="card-img-top"
                                                alt={`${vehicle.maker} ${vehicle.model}`}
                                                style={{ height: '200px', objectFit: 'cover' }}
                                            />
                                        )}
                                        <div className="card-body">
                                            <h5 className="card-title">{vehicle.maker} {vehicle.model}</h5>
                                            <p className="card-text">
                                                Year: {vehicle.year}<br />
                                                VIN: {vehicle.vin || 'N/A'}<br />
                                                Price: ${vehicle.price || 'N/A'}<br />
                                                Stock ID: {vehicle.stock_id || 'N/A'}
                                            </p>
                                            <Link to={`/vehicle-details/${vehicle.id}`} className="btn btn-primary">
                                                View Details
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="col-2 rightcol">
                    <RightSection />
                </div>
            </div>
        </>
    );
};

export default SearchVehicle;